import React, { useEffect } from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { useDispatch, useSelector } from 'react-redux';
import './VoucherWaitingListTranslation';
import { loadTableData, voucherWaitingListModule, clearState } from './VoucherWaitingListDucks';
import { voucherWaitingListColumn } from './VoucherWaitingListColumn';
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import VoucherWaitingListChildInfoModal from './VoucherWaitingListChildInfoModal';

export default function VoucherWaitingListPage() {
  const { t, i18n } = useTranslation();
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_waitingList') }
  ];
  const { tableData, loadingTable } = useSelector(
    state => state[voucherWaitingListModule]
  );
  const dispatch = useDispatch();
  const { nextPage } = useTableFilter(
    filter => dispatch(loadTableData(filter)),
    {
      pageNumber: 1,
      pageSize: 10
    },
    ''
  );
  const waitingListInfoModal = useSimpleModal();

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);


  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('waitingList_title')}</h3>
        <StaticTablePagination
          columns={voucherWaitingListColumn({
            t,
            lang: i18n.language
          })}
          data={tableData.content}
          sortable={false}
          loading={loadingTable}
          onClickRow={({ row }) => waitingListInfoModal.open({ row })}
          totalElements={tableData.totalElements}
          onClickLoadMore={() => nextPage()}
        />
      </Paper>
      {waitingListInfoModal.isOpen && (
        <VoucherWaitingListChildInfoModal
          {...waitingListInfoModal.data}
          open={waitingListInfoModal.isOpen}
          onClose={waitingListInfoModal.close}
          lang={i18n.language}
        />
      )}

    </>
  );
}
